import React from 'react';
import Button from '../common/Button';

export default function AdminAgencyForm({
    t,
    i18n,
    newAgency,
    setNewAgency,
    cities,
    handleCreateAgency,
    isRTL
}) {
    return (
        <div className="bg-bg-card border border-gold/20 shadow-lg rounded-2xl p-6">
            <h3 className={`text-lg font-bold text-text mb-6 ${isRTL ? 'text-right' : 'text-left'}`}>
                {t('addNewAgency')}
            </h3>
            <form onSubmit={handleCreateAgency} className="space-y-4">
                <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                    <div>
                        <label className="block text-sm font-medium text-text-muted mb-1">{t('agencyNameEnglish')} <span className="text-danger-500">*</span></label>
                        <input
                            type="text" placeholder={t('agencyNameEnglish')}
                            className="bg-bg-soft border border-gold/20 text-text rounded px-3 py-2 w-full focus:ring-gold focus:border-gold placeholder-textMuted/50"
                            value={newAgency.name_en} onChange={e => setNewAgency({ ...newAgency, name_en: e.target.value })} required
                        />
                    </div>
                    <div>
                        <label className="block text-sm font-medium text-text-muted mb-1">{t('agencyNameArabic')}</label>
                        <input
                            type="text" placeholder={t('agencyNameArabic')}
                            className="bg-bg-soft border border-gold/20 text-text rounded px-3 py-2 w-full text-right focus:ring-gold focus:border-gold placeholder-textMuted/50"
                            dir="rtl"
                            value={newAgency.name_ar} onChange={e => setNewAgency({ ...newAgency, name_ar: e.target.value })}
                        />
                    </div>
                    <div>
                        <label className="block text-sm font-medium text-text-muted mb-1">{t('clientEmail')} <span className="text-danger-500">*</span></label>
                        <input
                            type="email" placeholder={t('clientEmail')}
                            className="bg-bg-soft border border-gold/20 text-text rounded px-3 py-2 w-full focus:ring-gold focus:border-gold placeholder-textMuted/50"
                            value={newAgency.client_email} onChange={e => setNewAgency({ ...newAgency, client_email: e.target.value })} required
                            autoComplete="email"
                        />
                    </div>
                    <div>
                        <label className="block text-sm font-medium text-text-muted mb-1">{t('clientPassword')} <span className="text-danger-500">*</span></label>
                        <input
                            type="password" placeholder={t('clientPassword')}
                            className="bg-bg-soft border border-gold/20 text-text rounded px-3 py-2 w-full focus:ring-gold focus:border-gold placeholder-textMuted/50"
                            value={newAgency.client_password} onChange={e => setNewAgency({ ...newAgency, client_password: e.target.value })} required
                            autoComplete="new-password"
                        />
                    </div>
                </div>
                <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                    <input
                        type="text" placeholder={t('managerName')}
                        className="bg-bg-soft border border-gold/20 text-text rounded px-3 py-2 w-full focus:ring-gold focus:border-gold placeholder-textMuted/50"
                        value={newAgency.manager_name} onChange={e => setNewAgency({ ...newAgency, manager_name: e.target.value })}
                    />
                    <input
                        type="text" placeholder={t('phone')}
                        className="bg-bg-soft border border-gold/20 text-text rounded px-3 py-2 w-full focus:ring-gold focus:border-gold placeholder-textMuted/50"
                        value={newAgency.phone} onChange={e => setNewAgency({ ...newAgency, phone: e.target.value })}
                    />
                    <select
                        className="bg-bg-soft border border-gold/20 text-text rounded px-3 py-2 w-full focus:ring-gold focus:border-gold"
                        value={newAgency.city} onChange={e => setNewAgency({ ...newAgency, city: e.target.value })}
                    >
                        <option value="">{t('city')}</option>
                        {(cities || []).map(city => <option key={city.en} value={city.en}>{i18n.language === 'ar' ? city.ar : city.en}</option>)}
                    </select>
                </div>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                    <input
                        type="text" placeholder={t('address')}
                        className="bg-bg-soft border border-gold/20 text-text rounded px-3 py-2 w-full focus:ring-gold focus:border-gold placeholder-textMuted/50"
                        value={newAgency.address} onChange={e => setNewAgency({ ...newAgency, address: e.target.value })}
                    />
                    <input
                        type="text" placeholder={t('website')}
                        className="bg-bg-soft border border-gold/20 text-text rounded px-3 py-2 w-full focus:ring-gold focus:border-gold placeholder-textMuted/50"
                        value={newAgency.website} onChange={e => setNewAgency({ ...newAgency, website: e.target.value })}
                    />
                </div>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                    <input
                        type="text" placeholder={t('facebook')}
                        className="bg-bg-soft border border-gold/20 text-text rounded px-3 py-2 w-full focus:ring-gold focus:border-gold placeholder-textMuted/50"
                        value={newAgency.facebook} onChange={e => setNewAgency({ ...newAgency, facebook: e.target.value })}
                    />
                    <div>
                        <label className="block text-sm font-medium text-text-muted mb-1">{t('agencyLogo')}</label>
                        <input
                            type="file" accept="image/*"
                            className="bg-bg-soft border border-gold/20 text-text-muted rounded px-3 py-2 w-full file:mr-4 file:py-2 file:px-4 file:rounded-full file:border-0 file:text-sm file:font-semibold file:bg-gold-gradient file:text-white hover:file:opacity-90"
                            onChange={e => setNewAgency({ ...newAgency, logo: e.target.files[0] })}
                        />
                    </div>
                </div>
                <textarea
                    placeholder={t('description')}
                    className="bg-bg-soft border border-gold/20 text-text rounded px-3 py-2 w-full focus:ring-gold focus:border-gold placeholder-textMuted/50"
                    rows="3"
                    value={newAgency.description} onChange={e => setNewAgency({ ...newAgency, description: e.target.value })}
                />
                <Button type="submit" variant="primary" className="shadow-md">
                    {t('createAgency')}
                </Button>
            </form>
        </div>
    );
}
